export const permissions = {
  ReadAllHome: 'read_all-home',

  UpdateAllFinancesClients: 'update_all-finances_clients',
  DeleteFinancesClients: 'delete-finances_clients',
  ReadAllFinancesClients: 'read_all-finances_clients',
  ReadAllFinancesExpensesCategory: 'read_all-finances_expenses_category',
  ReadOwnFinancesExpensesCategory: 'read_own-finances_expenses_category',
  ReadAllFinancesProjectSpecialisations: 'read_all-finances_project_specialisations',
  CreateFinancesProjectSpecialisations: 'create-finances_project_specialisations',
  DeleteFinancesProjectSpecialisations: 'delete-finances_project_specialisations',
  DeleteOwnFinancesProjectSpecialisations: 'delete_own-finances_project_specialisations',
  UpdateAllFinancesProjectSpecialisations: 'update_all-finances_project_specialisations',
  UpdateOwnFinancesProjectSpecialisations: 'update_own-finances_project_specialisations',
  ReadAllFinancesClientBankDetails: 'read_all-finances_client_bank_details',
  ReadOwnFinancesClientBankDetails: 'read_own-finances_client_bank_details',
  CreateFinancesClientBankDetails: 'create-finances_client_bank_details',
  CreateOwnFinancesClientBankDetails: 'create_own-finances_client_bank_details',
  DeleteFinancesClientBankDetails: 'delete-finances_client_bank_details',
  DeleteOwnFinancesClientBankDetails: 'delete_own-finances_client_bank_details',
  UpdateAllFinancesClientBankDetails: 'update_all-finances_client_bank_details',
  UpdateOwnFinancesClientBankDetails: 'update_own-finances_client_bank_details',

  ReadAllFinancesOwnBankDetails: 'read_all-finances_own_bank_details',
  ReadOwnFinancesOwnBankDetails: 'read_own-finances_own_bank_details',
  CreateFinancesOwnBanDetails: 'create-finances_own_bank_details',
  CreateOwnFinancesOwnBankDetails: 'create_own-finances_own_bank_details',
  DeleteFinancesOwnBankDetails: 'delete-finances_own_bank_details',
  DeleteOwnFinancesOwnBankDetails: 'delete_own-finances_own_bank_details',
  UpdateAllFinancesOwnBankDetails: 'update_all-finances_own_bank_details',
  UpdateOwnFinancesOwnBankDetails: 'update_own-finances_own_bank_details',

  ReadAllFinancesContractorBankDetails: 'read_all-finances_contractors_bank_details',
  ReadOwnFinancesContractorBankDetails: 'read_own-finances_contractors_bank_details',
  CreateFinancesContractorBankDetails: 'create-finances_contractors_bank_details',
  CreateOwnFinancesContractorBankDetails: 'create_own-finances_contractors_bank_details',
  DeleteFinancesContractorBankDetails: 'delete-finances_contractors_bank_details',
  DeleteOwnFinancesContractorBankDetails: 'delete_own-finances_contractors_bank_details',
  UpdateAllFinancesContractorBankDetails: 'update_all-finances_contractors_bank_details',
  UpdateOwnFinancesContractorBankDetails: 'update_own-finances_contractors_bank_details',

  ReadAllFinancesPartnerBankDetails: 'read_all-finances_partners_bank_details',
  ReadOwnFinancesPartnerBankDetails: 'read_own-finances_partners_bank_details',
  CreateFinancesPartnerBankDetails: 'create-finances_partners_bank_details',
  CreateOwnFinancesPartnerBankDetails: 'create_own-finances_partners_bank_details',
  DeleteFinancesPartnerBankDetails: 'delete-finances_partners_bank_details',
  DeleteOwnFinancesPartnerBankDetails: 'delete_own-finances_partners_bank_details',
  UpdateAllFinancesPartnerBankDetails: 'update_all-finances_partners_bank_details',
  UpdateOwnFinancesPartnerBankDetails: 'update_own-finances_partners_bank_details',

  ReadAllFinancesInvoices: 'read_all-finances_invoices',
  ReadOwnFinancesInvoices: 'read_own-finances_invoices',
  CreateFinancesInvoices: 'create-finances_invoices',
  CreateOwnFinancesInvoices: 'create_own-finances_invoices',
  DeleteFinancesInvoices: 'delete-finances_invoices',
  DeleteOwnFinancesInvoices: 'delete_own-finances_invoices',
  UpdateAllFinancesInvoices: 'update_all-finances_invoices',
  UpdateOwnFinancesInvoices: 'update_own-finances_invoices',

  ReadAllFinancesExpenses: 'read_all-finances_expenses',
  ReadOwnFinancesExpenses: 'read_own-finances_expenses',
  ReadAllFinancesReportProfitAndLoss: 'read_all-finances_report_profit_and_loss',
  ReadAllFinancesPPReportMoney: 'read_all-finances_pp_report_money',
  ReadAllFinancesReportBalances: 'read_all-finances_report_balances',
  ReadAllFinancesPPReportProfitability: 'read_all-finances_pp_report_profitability',
  UpdateAllLogTimeReports: 'update_all-log_time_reports',
  ReadOwnLogTimeReports: 'read_own-log_time_reports',

  ReadAllFinancesPayouts: 'read_all-finances_payouts',
  ReadOwnFinancesPayouts: 'read_own-finances_payouts',
  CreateFinancesPayouts: 'create-finances_payouts',
  CreateOwnFinancesPayouts: 'create_own-finances_payouts',
  DeleteFinancesPayouts: 'delete-finances_payouts',
  DeleteOwnFinancesPayouts: 'delete_own-finances_payouts',
  UpdateAllFinancesPayouts: 'update_all-finances_payouts',
  UpdateOwnFinancesPayouts: 'update_own-finances_payouts'
}

export default {
  permissions
}
